import React from 'react';
import Container from '@amzn/awsui-components-console/container';
import SpaceBetween from '@amzn/awsui-components-console/space-between';
import Box from '@amzn/awsui-components-console/box';
import Table from '@amzn/awsui-components-console/table';
import Badge from '@amzn/awsui-components-console/badge';
import { COMPARISON_ITEMS, ComparisonItem } from '../../constants';
import styles from './AstVsLangHub.module.scss';

const AstVsLangHub: React.FC = () => (
  <section
    aria-label="AST vs LangHub"
    className={styles.section}
    id="ast-vs-langhub"
  >
    <Container>
      <SpaceBetween size="l">
        <Box textAlign="center">
          <SpaceBetween size="xs">
            <Box
              variant="h2"
              fontSize="heading-xl"
              fontWeight="bold"
              textAlign="center"
            >
              AST vs LangHub
            </Box>
            <Box variant="p" color="text-body-secondary" textAlign="center">
              Everything you do in AST today comes across to LangHub — here is
              what changes, and what you gain.
            </Box>
          </SpaceBetween>
        </Box>
        <div className={styles.tableWrapper}>
          <Table<ComparisonItem>
            variant="borderless"
            trackBy="capability"
            wrapLines={true}
            sortingDisabled={true}
            columnDefinitions={[
              {
                id: 'capability',
                header: <Box variant="strong">Capability</Box>,
                minWidth: 160,
                cell: (item) => <Box variant="strong">{item.capability}</Box>,
              },
              {
                id: 'ast',
                header: <Box variant="strong">AST</Box>,
                minWidth: 180,
                cell: (item) => (
                  <Box color="text-status-inactive">{item.ast}</Box>
                ),
              },
              {
                id: 'langhub',
                header: <Box variant="strong">LangHub</Box>,
                minWidth: 220,
                cell: (item) => (
                  <SpaceBetween
                    direction="horizontal"
                    size="xs"
                    alignItems="center"
                  >
                    <Box display="inline">{item.langhub}</Box>
                    {item.comingSoon ? (
                      <Badge color="severity-medium">Coming soon</Badge>
                    ) : null}
                  </SpaceBetween>
                ),
              },
            ]}
            items={COMPARISON_ITEMS}
          />
        </div>
      </SpaceBetween>
    </Container>
  </section>
);

export default AstVsLangHub;
